enum CommonIds {
	loadingIndicator = 'loading-indicator',
	inactiveAccount = 'inactive-account',
}

export default CommonIds;
